import { Component, OnInit, Input } from '@angular/core';
import { DataType } from '../widget-configuration';

const DEFAULT_CONFIG: ISummaryWidgetConfig = {
  primaryColor: 'bg-gray-dark',
  secondaryColor: 'bg-inverse',
  icon: 'fa fa-wrench',
  text: 'change me',
  dataType: DataType.Number
};

@Component({
  selector: 'app-widget-summary',
  templateUrl: './summary-widget.component.html',
  styleUrls: ['./summary-widget.component.scss']
})
export class SummaryWidgetComponent implements OnInit {

  @Input() public value = '0';
  @Input() public cfg: ISummaryWidgetConfig;

  constructor() { }

  public ngOnInit() {
    if (!this.cfg) {
      this.cfg = DEFAULT_CONFIG;
    }
  }

}

export interface ISummaryWidgetConfig {
  primaryColor: string;
  secondaryColor: string;
  icon: string;
  text: string;
  dataType: string;
}
